import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { useTranslation } from "@/hooks/useTranslation";

interface WeddingScheduleSectionProps {
  civilEnabled: boolean;
  religiousEnabled: boolean;
  partyEnabled: boolean;
  onCivilChange: (enabled: boolean) => void;
  onReligiousChange: (enabled: boolean) => void;
  onPartyChange: (enabled: boolean) => void;
  /** When true (baptism-only), civil and religious toggles are hidden; religious slot is shown as "Baptism ceremony" */
  isBaptismOnly?: boolean;
  /** JUB-154: wedding + baptism events get a toggle for a separately held baptism. */
  showBaptismSlot?: boolean;
  baptismEnabled?: boolean;
  onBaptismChange?: (enabled: boolean) => void;
}

export function WeddingScheduleSection({
  civilEnabled,
  religiousEnabled,
  partyEnabled,
  onCivilChange,
  onReligiousChange,
  onPartyChange,
  isBaptismOnly = false,
  showBaptismSlot = false,
  baptismEnabled = false,
  onBaptismChange,
}: WeddingScheduleSectionProps) {
  const { t } = useTranslation();
  const toggles = [
    ...(isBaptismOnly
      ? []
      : [
          {
            id: "civil-toggle",
            label: t("events.form.civilCeremony"),
            checked: civilEnabled,
            onCheckedChange: onCivilChange,
          },
        ]),
    {
      id: "religious-toggle",
      label: isBaptismOnly ? t("events.form.baptismCeremony") : t("events.form.religiousCeremony"),
      checked: religiousEnabled,
      onCheckedChange: onReligiousChange,
    },
    ...(showBaptismSlot && onBaptismChange
      ? [
          {
            id: "baptism-slot-toggle",
            label: t("events.form.ceremony.baptism"),
            checked: baptismEnabled,
            onCheckedChange: onBaptismChange,
          },
        ]
      : []),
    {
      id: "party-toggle",
      label: t("events.form.party"),
      checked: partyEnabled,
      onCheckedChange: onPartyChange,
    },
  ];
  return (
    <div className="space-y-4">
      <Label>{t("events.form.weddingSchedule")}</Label>
      <div className={`grid grid-cols-1 gap-3 ${toggles.length === 4 ? "sm:grid-cols-2 md:grid-cols-4" : toggles.length === 3 ? "sm:grid-cols-3" : "sm:grid-cols-2"}`}>
        {toggles.map(({ id, label, checked, onCheckedChange }) => (
          <div key={id} className="flex items-center justify-between gap-3 rounded-lg border p-3">
            <Label htmlFor={id} className="cursor-pointer">
              {label}
            </Label>
            <Switch id={id} checked={checked} onCheckedChange={onCheckedChange} />
          </div>
        ))}
      </div>
    </div>
  );
}

